import { ApplicationSession } from './types';

export const blankUserSession: ApplicationSession = {
  token: null,
  refreshToken: null,
  signedIn: false,
  expiresAt: null,
  refreshTokenExpiresAt: null,
  isMaster: false,
};
